<template>
  <li>
    <!-- Check if value exists, if not, transform to lowercase -->
    <a
      v-if="item.value === undefined"
      :class="{ 'is-Active': searchParams[param] === item.toLowerCase().trim().replace(/ /g, '_') }"
      @click="filter({ [param]: item.toLowerCase().trim().replace(/ /g, '_') })"
      >{{ $store.getters.getStringTranslation(item.replace(/\s/g, '').toLowerCase()) }}
    </a>

    <!-- Convert label to lower case for both class comparison and to pass data into main parameter -->
    <a
      v-else
      :class="{ 'is-Active': JSON.stringify(searchParams[param]) === JSON.stringify(item.value) }"
      @click="filter({ [param]: item.value })"
    >
      <template v-if="item.icon"><icon :name="item.label" :weight="item.weight"></icon></template>
      <template v-else>{{ item.label }}</template>
    </a>
  </li>
</template>

<script>
export default {
  name: 'FilterItem',
  props: ['item', 'searchParams', 'filter', 'param'],
}
</script>
